<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="trello-logout-mian col-md-12">
          <button class="trello-logout" @click="openLogoutModal">
            Trello Logout
            <i class="fa fa-sign-out-alt performance-header-search-icon ml-1"></i>
          </button>
        </div>
        <div class="col-md-12">
          <div class="performance-header-container">
            <div class="dropdowns-container">
              <div class="admin-access-section">
                <HeaderEmployeeDropdown
                  :disabled="loading"
                  v-if="isAdmin"
                  :items="employeeList"
                  labelKey="username"
                  searchable
                  @select="onEmployeeSelect"
                  :placeholder="selectedEmployee ? selectedEmployee.username : 'Select Employee'"
                />
              </div>
              <div style="width: 245px" v-if="isAdmin"></div>
              <div class="searchable-1">
                <SearchableDropdown
                  :items="filteredBoardsForEmployee"
                  labelKey="name"
                  :placeholder="selectedBoardName || 'All Projects'"
                  @select="onBoardSelect"
                  :disabled="loading"
                />
              </div>
              <div class="searchable-2">
                <SearchableDropdown
                  :items="months.map(m => ({ name: m }))"
                  labelKey="name"
                  :placeholder="selectedMonth || 'Select Month'"
                  @select="onMonthSelect"
                  :disabled="loading"
                />
              </div>
              <div class="searchable-3">
                <SearchableDropdown
                  :items="years.map(y => ({ name: y.toString() }))"
                  labelKey="name"
                  :placeholder="selectedYear || 'Select Year'"
                  @select="onYearSelect"
                  :disabled="loading"
                />
              </div>
              <div class="performance-header-actions">
                <button class="btn btn-outline" @click="triggerSearch" :disabled="loading || !selectedEmployee || !selectedMonth || !selectedYear">
                  <i class="fa fa-search performance-header-search-icon"></i>
                </button>
              </div>
            </div>
            <div v-if="showLockBar && (isScheduled || effectiveLocked) && (!isLoading || !scheduledloading)" class="lock-bar">
            <span v-if="isScheduled ">
              Modifying below will be locked on {{formatDate(lockData.scheduledLockTime)}} at {{formatTime(lockData.scheduledLockTime)}}. Time Remaining: {{timeRemaining}}.
            </span>
            <span v-else>Modifying below is locked now.</span>
          </div>
          </div>
        </div>
        <div class="add-items-mian col-md-12">
          <button class="lock-button" v-if="!effectiveLocked && showLockBar" @click="isAddModalOpen = true">
           <i class="fa fa-plus" style="font-size:0.9em;"></i> Add Item
           </button>
          <button v-if="isAdmin && showLockBar" class="lock-button" @click="onLockButtonClick">
           <i :class="lockButtonText === 'Lock' ? 'fas fa-lock' :lockButtonText === 'Unlock' ? 'fas fa-unlock' : 'fas fa-calendar'" style="font-size:0.9em;"></i> {{ lockButtonText }}
          </button>
          <button v-if="isAdmin && isScheduled && showLockBar" class="end-schedule" @click="openEndScheduleModal">
           <i class="fas fa-times" style="font-size:1em;"></i> Cancel Schedule
           </button>
        </div>
        <div style="min-height: 450px; position: relative; border-radius: 8px; text-align: center;" class="col-md-12">
          <div style="margin:20px 0px;" v-if="(!loading && !error && !noMemberFound && summaryCards.length > 0) && showLockBar">
            <CardsSection :cards="summaryCards" :showScoreInfo="true" />
          </div>

          <div v-if="loading" class="payroll-table-loader-overlay">
            <div class="payroll-loader-container">
              <DoubleLoader class="payroll-loader" />
            </div>
          </div>

          <div v-else-if="selectedEmployee && filteredBoardsForEmployee.length === 0 && membersLoaded" class="text-center py-5">
            <div class="alert alert-info d-inline-block">
              <i class="fa fa-info-circle"></i>
              <strong>{{ selectedEmployee.username }}</strong> is not a member of any board.
            </div>
          </div>
          <div v-else-if="!loading && isAdmin && !hasSearched || !showLockBar" class="text-center py-5">
            <div class="alert alert-info d-inline-block">
              <i class="fa fa-info-circle"></i>
              Kindly set the filter and press the search button
            </div>
          </div>

          <div v-else-if="!loading && filteredPerformanceData.length === 0" class="text-center py-5">
            <div class="alert alert-info d-inline-block">
              <i class="fa fa-info-circle"></i>
              <strong>No cards found for the selected criteria.</strong>
            </div>
          </div>

          <div v-else-if="error" class="alert alert-danger text-center">
            {{ error }}
          </div>

          <div v-else>
            <CustomTable
              :columns="tableColumns"
              :data="filteredPerformanceData"
              :totals="tableTotals"
              :showModal="true"
              @row-click="handleRowClick"
              :footer="true"
            >
              <template #serialNumber="{ index }">{{ index + 1 }}.</template>
              <template #taskName="{ item }">
                <span v-if="!item.link || item.link === '#'" class="" :title="item.taskName">
                  {{ item.taskName.length > 25 ? item.taskName.slice(0, 25) + '...' : item.taskName }}
                </span>
                <a v-else :href="item.link" class="task-link" :title="item.taskName" target="_blank">
                  {{ item.taskName.length > 25 ? item.taskName.slice(0, 25) + '...' : item.taskName }}
                </a>
                <span 
                  v-if="Array.isArray(item.details) && item.details.length > 0"
                  class="detail-tooltip-wrapper"
                  @mouseover="showDetails(item.id)"
                  @mouseleave="hideDetails(item.id)"
                >
                  <i class="fa fa-info-circle text-info pointer info-icon ml-1"></i>
                  <div
                    v-if="visibleDetails[item.id]"
                    class="detail-tooltip-box"
                  >
                    <div class="details-title">
                      PR Review / Help
                    </div>
                    <ul class="details-list">
                      <li class="detail-item" v-for="(detail, index) in item.details"
                        :key="index"
                      >
                        <template v-if="detail && typeof detail === 'object'">
                          <a
                            v-if="detail.link && detail.link.startsWith('http')"
                            :href="detail.link"
                            target="_blank"
                          >
                            {{ detail.link }}
                          </a>
                          <span v-else-if="detail.link">
                            {{ detail.link }}
                          </span>
                          <span v-if="detail.text" class="detail-text">
                            {{ detail.text }}
                          </span>
                        </template>
                        <span v-else class="detail-text">
                          {{ detail }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </span>
              </template>
              <template #durationSpent="{ item }">{{ item.durationSpent }}</template>
              <template #movedToDone="{ item }"><span :title="item.movedToDone">{{ item.movedToDone }}</span></template>
              <template #reopened="{ item }">
              <div v-if="item.isCustom && item.type !== 'Ticket'" class="reopened-cell">
                  <span >
                    {{ item.reopened==0 ? 'N/A' : item.reopened }}
                  </span>
                </div>
                <div v-else class="reopened-cell">
                  <div v-if="item.status === 'pending'" class="reopened-edit">
                    <span class="text-muted line-through" style="font-weight: bold">{{ item.originalreopenCount != null ? item.originalreopenCount : 0 }}</span>
                    →
                    <span class=" font-bold" style="font-weight: bold; ">{{ item.reopened != null ? item.reopened : 0 }}</span>
                 
                    <div class="edit-actions" v-if="isAdmin && !effectiveLocked">
                      <button
                        class="action-save"
                        @click.stop="openConfirm('approve', item, 'reopened')"
                        title="Approve"
                      >
                        <i class="fa fa-check"></i>
                      </button>
                      <button
                        class="action-cancel"
                        @click.stop="openConfirm('reject', item, 'reopened')"
                        title="Reject"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                  
                    </div>
                    <span class="" style="font-size: 10px; color: #5EC1A5;" v-if="!isAdmin">(Pending)</span>
                    <i
                      v-if="getReasonForField(item.id, 'reopened')"
                      class="fa fa-info-circle text-info pointer info-icon"
                      @mouseenter="showInfo($event, item.id, 'reopened')"
                      @mouseleave="hideInfo"
                    ></i>
                  </div>
                  <div v-else>
                  <!-- View mode -->
                    <div v-if="!isEditing(item.id, 'reopened')" class="reopened-view">
                      <button
                        class="reopened-badge"
                        @click="startEdit(item.id, 'reopened', item.reopened)"
                        v-if="canEdit('reopened') && !effectiveLocked"
                        :title="'Edit reopened count'"
                        :disabled="item.ticketStatus === 'pending'"
                      >
                        <i class="fa fa-edit"></i>
                        <span class="reopened-count">{{ item.reopened != null ? item.reopened : 0 }}</span>
                      </button>
                      <div v-else class="reopened-badge disabled">
                        <i class="fa fa-edit"></i>
                        <span class="reopened-count">{{ item.reopened != null ? item.reopened : 0 }}</span>
                      </div>

                      <span class="icon-slot" role="img" aria-hidden="true">
                        <i
                          v-if="getReasonForField(item.id, 'reopened')"
                          class="fa fa-info-circle pointer info-icon"
                          @mouseenter="showInfo($event, item.id, 'reopened')"
                          @mouseleave="hideInfo"
                          title="View reopen reason"
                        ></i>

                        <i
                          v-else
                          class="fa fa-info-circle info-icon-disabled"
                          title="No reopen reason"
                        ></i> 
                      </span>
                    </div>
                    <!-- Edit mode -->
                    <div v-else class="reopened-edit">
                      <input
                        v-model="tempValues[`${item.id}-reopened`]"
                        type="number"
                        min="0"
                        class="edit-input"
                      />
                      <div class="edit-actions">
                        <button
                          class="action-save"
                          @click="confirmEdit(item, 'reopened', item.reopened, item.reopenReason)"
                          title="Save"
                        >
                          <i class="fa fa-check"></i>
                        </button>
                        <button
                          class="action-cancel"
                          @click="cancelEdit(item.id, 'reopened')"
                          title="Cancel"
                        >
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #deadlineMissed="{ item }">{{ item.deadlineMissed }}</template>
              <template #score="{ item }">
                <div v-if="!isAdmin" class="reopened-cell">                 
                  <span >
                    {{ item.score }}
                  </span>
                  <span class="icon-slot" role="img" aria-hidden="true">
                    <i
                      v-if="getReasonForField(item.id, 'score')"
                      class="fa fa-info-circle pointer info-icon"
                      @mouseenter="showInfo($event, item.id, 'score')"
                      @mouseleave="hideInfo"
                      title="View score reason"
                    ></i>

                    <i
                      v-else
                      class="fa fa-info-circle info-icon-disabled"
                      title="No score reason"
                    ></i>
                  </span>
                  <span class="pending-status" v-if="item.ticketStatus === 'pending' && !isAdmin">(<span class="pending-text">Pending</span>)</span>
                </div>
                <div v-else class="reopened-cell">
                  <!-- View mode -->
                  <div v-if="!isEditing(item.id, 'score')" class="reopened-view">
                    <button
                      class="reopened-badge"
                      @click="startEdit(item.id, 'score', item.score)"
                      v-if="canEdit('score') && !effectiveLocked"
                      :title="'Edit score'"
                      :disabled="item.ticketStatus === 'pending'"
                    >
                      <i class="fa fa-edit"></i>
                      <span class="reopened-count">{{ item.score }}</span>
                    </button>

                    <div v-else class="reopened-badge disabled">
                      <i class="fa fa-edit"></i>
                      <span class="reopened-count">{{ item.score }}</span>
                    </div>

                    <span class="icon-slot" role="img" aria-hidden="true">
                      <i
                        v-if="getReasonForField(item.id, 'score')"
                        class="fa fa-info-circle pointer info-icon"
                        @mouseenter="showInfo($event, item.id, 'score')"
                        @mouseleave="hideInfo"
                        title="View score reason"
                      ></i>

                      <i
                        v-else
                        class="fa fa-info-circle info-icon-disabled"
                        title="No score reason"
                      ></i>
                    </span>
                    
                  </div>

                  <!-- Edit mode -->
                  <div v-else class="reopened-edit">
                    <input
                      v-model="tempValues[`${item.id}-score`]"
                      type="number"
                      step="0.5"
                      min="0"
                      class="edit-input"
                    />
                    <div class="edit-actions">
                      <button
                        class="action-save"
                        @click="confirmEdit(item, 'score', item.score, item.scoreReason)"
                        title="Save"
                      >
                        <i class="fa fa-check"></i>
                      </button>
                      <button
                        class="action-cancel"
                        @click="cancelEdit(item.id, 'score')"
                        title="Cancel"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                 <span class="pending-status" v-if="item.ticketStatus === 'pending' && !isAdmin">(<span class="pending-text">Pending</span>)</span>
                </div>
  
              </template>

              <template #project="{ item }">
                {{ item.isCustom && item.type === 'Ticket' || item.type=="Lead Per Project"|| !item.isCustom
                    ? truncateText(item.project || item.boardName, 20) : 'N/A'
                }}
              </template>
              <template #action="{ item }">
                <span v-if="effectiveLocked"  style="display: flex; align-items: center; justify-content:center;">
                  <i  class="fa fa-history pointer" 
                      :class="{ 'text-primary': hasHistory(item.id), 'text-muted opacity-50': !hasHistory(item.id) }"
                      :title="hasHistory(item.id) ? 'History' : 'No history available'"
                      @click.stop="hasHistory(item.id) && onHistoryClick(item)"
                      style="cursor: pointer;"
                  ></i>
                </span>
               <span class="action" v-if="item.ticketStatus !== 'pending' && isAdmin && !effectiveLocked">
                  <i class="fa fa-trash delete-icon pointer"
                     :class="{ 'delete-icon': !editedCards[item.id], 'opacity-60': !editedCards[item.id] }"
                     :style="{ 'pointer-events': editedCards[item.id] ? 'auto' : 'none' }"
                     title="Delete edit (Firebase only)"
                     @click.stop="editedCards[item.id] && onDeleteClick(item)" 
                  ></i>
                  <i 
                    class="fa fa-history pointer" 
                    :class="{ 'text-primary': hasHistory(item.id), 'text-muted opacity-50': !hasHistory(item.id) }"
                    :title="hasHistory(item.id) ? 'History' : 'No history available'"
                    @click.stop="hasHistory(item.id) && onHistoryClick(item)"
                    style="cursor: pointer;"
                  ></i>
                 
                  <i class="fa fa-edit pointer" 
                    :class="{ 'text-primary': true }"
                    title="Edit item"
                    @click.stop="onEditClick(item)"
                    style="cursor: pointer;"></i>
                </span>
                <span v-if=" !isAdmin && !effectiveLocked" class="action-user">
                 <i class="fa fa-trash delete-icon pointer"
                     :class="{ 'delete-icon': !editedCards[item.id], 'opacity-60': !editedCards[item.id] }"
                     :style="{ 'pointer-events': editedCards[item.id] ? 'auto' : 'none' }"
                     title="Delete edit (Firebase only)"
                     @click.stop="editedCards[item.id] && onDeleteClick(item)" 
                  ></i>
                 <i 
                    class="fa fa-history pointer" 
                    :class="{ 'text-primary': hasHistory(item.id), 'text-muted opacity-50': !hasHistory(item.id) }"
                    :title="hasHistory(item.id) ? 'History' : 'No history available'"
                    @click.stop="hasHistory(item.id) && onHistoryClick(item)"
                    style="cursor: pointer;"
                  ></i>
                  
                  <i class="fa fa-edit pointer" 
                    :class="{ 'text-primary': true }"
                    title="Edit item"
                    @click.stop="onEditClick(item)"
                    style="cursor: pointer;"
                    v-if="item.ticketStatus == 'pending' && !effectiveLocked"
                    ></i>
                </span>
                <span v-if="item.ticketStatus === 'pending' && isAdmin && !effectiveLocked" class="action">
                    <button class=" actoin-column-save" @click.stop="onApproveClick(item)" title="Approve Item">
                      <i class="fa fa-check"></i>
                    </button>
                    <button class="actoin-column-cancel" @click.stop="onDeleteClick(item)" title="Reject Item">
                      <i class="fa fa-times"></i>
                    </button>
                    <i class="fa fa-edit pointer" 
                      :class="{ 'text-primary': true }"
                      title="Edit item"
                      @click.stop="onEditClick(item)"
                      style="cursor: pointer;"
                     ></i>
                </span>
              </template>
            </CustomTable>
          </div>
          <div v-if="showTooltip"
               class="performance-tooltip"
               :style="{ top: tooltipY + 'px', left: tooltipX + 'px' }">
            {{ getReasonForField(showTooltip, currentHoverField) }}
          </div>
          <ReuseableModal
            :modelValue="isHistoryModalOpen"
            @update:modelValue="isHistoryModalOpen = $event"
            title="Activity History"
            submitButtonText="Close"
            :xlarge="true"
            :hideCancelButton="true"
            @submit="closeHistoryModal"
          >
            <template #default>
              <HistoryActivityTable :activities="performanceActivity" :columns="columns" @open-map="openMapPopup" />
            </template>
          </ReuseableModal>
          <ReuseableModal
            :modelValue="showReasonModal"
            @update:modelValue="showReasonModal = $event"
            :title="reasonModalTitle"
            submitButtonText="Confirm"
            @submit="handleReasonSubmit"
            :loading="isLoading"
          >
            <template #default>
            <div style="padding: 7px 13px" >
              <div class="changed-value" >
                <label class="reason-label" >
                  {{ pendingAction ? pendingAction + ' Change' : changeInfo.field + ' Change' }}
                </label>
                <div style="display:flex; align-items:center">
                <span style=""  class="mr-1">
                  {{ changeInfo.original || '0' }}
                </span>
                   →   
                <span v-if="changeInfo.new !== undefined" class="ml-1">{{ changeInfo.new }}</span>
                </div>
              </div>
              <div class="reason-container" style="margin-top: 15px;">
                <label class="reason-label">Reason <span style="color: red" v-if="!isAdmin">*</span> </label>
                <textarea v-model="reason"
                placeholder="Enter reason here" 
                class="form-control"  
                rows="3"
                style="width: 100%;"
                maxlength="400" />
                <div style="text-align: right; font-size: 12px; color: gray; margin-top: 4px;">
                  {{ reason.length }} / 400
                </div>
              </div>
              </div>
            </template>
          </ReuseableModal>
          <ReuseableModal
            :modelValue="isDeleteModalOpen"
            @update:modelValue="isDeleteModalOpen = $event"
            title="Confirm Deletion"
            submitButtonText="Delete"
            submitButtonClass="btn-danger"
            @submit="confirmDelete"
            :loading="isLoading"
          >
            <div>Are you sure you want to delete this card? This action cannot be undone.</div>
          </ReuseableModal>
          <ReuseableModal
            :modelValue="isLogoutModalOpen"
            @update:modelValue="isLogoutModalOpen = $event"
            title="Confirm Logout"
            submitButtonText="Logout"
            submitButtonClass="btn-danger"
            @submit="confirmLogout"
          >
            <div>Are you sure you want to logout from Trello?</div>
          </ReuseableModal>

          <ReuseableModal
            :modelValue="mapPopup"
            @update:modelValue="mapPopup = $event"
            title="Activity Location"
            submitButtonText="Close"
            :xlarge="true"
            :hideCancelButton="true"
            @submit="mapPopup = false"
          >
            <template #default>
              <div v-if="currentCoordinates.latitude" style="width: 100%; height: 250px; border-radius: 8px; overflow: hidden;" id="mapActivity">
              </div>
              <div v-else class="text-center py-5 text-muted">
                <p>No location data available.</p>
              </div>
            </template>
          </ReuseableModal>
          <ReuseableModal
            :modelValue="isApproveModalOpen"
            @update:modelValue="isApproveModalOpen = $event"
            title="Confirm Approval"
            submitButtonText="Approve"
            submitButtonClass="btn-success"
            @submit="confirmApprove"
            :loading="isLoading"
          >
            <div>Are you sure you want to approve this ticket?</div>
          </ReuseableModal>
          <ReuseableModal
            :modelValue="isUnLockModalOpen"
            @update:modelValue="isUnLockModalOpen = $event"
            title="Confirm Unlock"
            submitButtonText="Unlock"
            submitButtonClass="btn-warning"
            @submit="confirmUnLock"
            :loading="isLoading"
          >
            <div>Are you sure you want to unlock?</div>
          </ReuseableModal>
          <ReuseableModal
            :modelValue="isEndScheduleModalOpen"
            @update:modelValue="isEndScheduleModalOpen = $event"
            title="Confirm End Schedule"
            submitButtonText="End Schedule"
            submitButtonClass="btn-danger"
            @submit="confirmEndSchedule"
            :loading="isLoading"
          >
            <div>Are you sure you want to end the schedule?.</div>
          </ReuseableModal>
          <ReuseableModal
            :modelValue="isLockModalOpen"
            @update:modelValue="isLockModalOpen = $event"
            title="Schedule Lock / Lock Now"
            submitButtonText="Lock Now"
            cancelButtonText="Cancel"
            @submit="lockNow"
            :loading="isLoading"
          >
            <template #default>
              <div class="lock-schedule" style="display: flex; justify-content: start; align-items: start; flex-direction: column; gap:5px;">
                <label>Schedule Lock Date & Time:</label>
                <div style="display:flex; gap:20px; width: 100%; border-radius: 4px; margin-bottom: 10px;">
                  <input type="date" v-model="lockDate" value="" style="width: 50%; margin: 0; padding: 5px;" />
                  <input type="time" v-model="lockTime" value="" style="width: 50%; margin: 0; padding: 5px; height: 43px; border: 1px solid #ccc; border-radius: 4px;" />
                </div>
              </div>
            </template>
            <template #middle-footer>
              <button class="lock-button" @click="scheduleLock" :disabled="scheduledloading || isLoading" style="min-width: 120px; margin-right: -75px;">
                <span v-if="scheduledloading">
                  <img src="/static/img/loader.gif" alt="Loading" style="width:18px; height:18px;vertical-align:middle;" />
                </span>
                <span v-else> Schedule Lock </span>
              </button>
            </template>
          </ReuseableModal>
          <AddPerformanceItemModal
            v-if="isAddModalOpen"
            :modelValue="isAddModalOpen"
            @update:modelValue="handleModalClose($event)"
            :employee="selectedEmployee"
            :month="selectedMonth"
            :year="selectedYear"
            :boards="filteredBoardsForEmployee"
            :isAdmin="isAdmin"
            :existingItem="selectedItem"
            @submitted="onItemAdded"
            @updated="onItemUpdated"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from "src/components/UIComponents/CustomTable.vue";
import SearchableDropdown from 'src/components/UIComponents/Dropdowns/SearchableDropdown.vue';
import HeaderEmployeeDropdown from 'src/components/UIComponents/HeaderEmployeeDropdown.vue';
import ReuseableModal from "../UIComponents/ReuseableModal.vue";
import DoubleLoader from "src/components/UIComponents/loaders/DoubleLoader.vue";
import CardsSection from "../LeaveManagement/CardsSection.vue";
import HistoryActivityTable from "src/components/UIComponents/HistoryActivityTable.vue";
import AddPerformanceItemModal from './AddPerformanceItemModal.vue'; // New component
import Swal from 'sweetalert';
import firebase from '@/assets/config/firebase';
import firebaseDB from "@/assets/config/firebase";
import { logAdminActivity } from "../../utils/adminLogs.js";   

import {
  formatDuration,
  formatMovedToDone,
  parseDurationString,
  sortByMovedDate,
  removeNullFields
} from './performanceHelper.js';
import { handleActivityNotification } from "../../services/notificationService.js";

export default {
  props: {
    selectedEmployeeTrelloUsername: {
      type: String,
      default: ""
    }
  },
  components: {
    CustomTable,
    SearchableDropdown,
    HeaderEmployeeDropdown,
    ReuseableModal,
    DoubleLoader,
    CardsSection,
    HistoryActivityTable,
    AddPerformanceItemModal,
  },
  data() {
    return {
      currentTime: Date.now(),
      selectedEmployeeTrelloUsername:"",
      isLogoutModalOpen: false,
      isAddModalOpen: false,
      mapPopup: false,
      currentCoordinates: null,
      loading: false,
      isLoading: false,
      error: null,
      noMemberFound: false,
      selectedBoardId: "",
      selectedBoardName: "",
      selectedMemberId: "",
      selectedMemberName: "",
      startDate: "",
      endDate: "",
      boards: [],
      showLockBar: false,
      doneCards: [],
      selectedItem: null,
      isModalOpen: false,
      isHistoryModalOpen: false,
      TRELLO_API_KEY: process.env.PROD_VUE_APP_TRELLO_API_KEY,
      TRELLO_TOKEN: process.env.PROD_VUE_APP_TRELLO_API_TOKEN,
      tableColumns: [
        { label: "S. No", key: "sno", sortable: true },
        { label: "Tasks", key: "taskName", sortable: true, width: 200 },
        { label: "Project", key: "project", sortable: true },
        { label: "Duration Spent", key: "durationSpent", sortable: true },
        { label: "Moved to Done", key: "movedToDone", sortable: true },
        { label: "Reopened", key: "reopened", sortable: true, width: 130 },
        { label: "Deadline Missed", key: "deadlineMissed", sortable: true },
        { label: "Score", key: "score", sortable: true, width: 130 },
        { label: "Action", key: "action", sortable: false }
      ],
      columns: [
        { label: "Activity On", key: "activityOnUserName", width: "200px" },
        { label: "Activity By", key: "activityByUserName", width: "200px" },
        { label: "Action", key: "action", width: "200px"},
        { label: "Field", key: "field", width: "120px" },
        { label: "Change", key: "change"},
        { label: "Reason", key: "reason",width: "250px",truncate: true, length: 30 },
        { label: "Timestamp", key: "timestamp", width: "250px", truncate: true, length: 20 },
        { label: "OS", key: "osName" },
        { label: "Browser", key: "browserName" },
        { label: "Map", key: "map", width: "70px" },
      ],
      isAdmin: false,
      selectedEmployee: null,
      user: this.$store.state.auth.user,
      employeeList: [],
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      selectedMonth: "",
      years: Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i),
      selectedYear: new Date().getFullYear().toString(),
      autoLoadDone: false,
      boardMemberCache: {},
      membersLoaded: false,
      performanceActivity: [],
      editing: {},
      tempValues: {},
      showReasonModal: false,
      changeInfo: {},
      reason: '',
      editedCards: {},
      customCards: [],
      showTooltip: null,
      tooltipX: 0,
      tooltipY: 0,
      currentHoverField: null,  
      isDeleteModalOpen: false,
      cardToDelete: null,
      pendingAction: null,
      pendingCardId: null,
      pendingField: null,
      selectedItem: null,
      isApproveModalOpen: false,
      cardToApprove: null,
      visibleDetails: {},
      visibleReasons: {},
      isSaveConfirmModalOpen: false,
      tableData: [],
      lockData: {locked: false, scheduledLockTime: null, userIds: {}},
      timeRemaining: '00:00:00',
      interval: null,
      isLockModalOpen: false,
      lockDate: '',
      lockTime: '',
      hasSearched: false,
      criteriaList: [],
      reopenEvery: null,
      reopenScore: null,
      deadlineEvery: null,
      deadlineScore: null,
      reopenLimit: null,
      deadlineLimit: null,
      scheduledloading: false,
      isUnLockModalOpen: false,
      isEndScheduleModalOpen: false,
      hasUnmatchedTrelloCards: false,
      scheduledLockSaveFired: false,
    };
  },
  computed: {
    effectiveLocked() {
      return this.lockData.locked || (this.lockData.scheduledLockTime && this.lockData.scheduledLockTime <= this.currentTime);
    },
    isScheduled() {
            return !!this.lockData.scheduledLockTime && this.lockData.scheduledLockTime > this.currentTime;
    },
    lockButtonText() {
      if (this.effectiveLocked) return 'Unlock';
      if (this.isScheduled) return 'Reschedule Lock';
      return 'Lock';
    },
    hasHistory() {
      return (cardId) => {
        const edit = this.editedCards[cardId];
        if (!edit) return false;
        // If there's any updated field or status change → there is history
        const upd = edit.updatedData || {};
        if (upd.reopened || upd.score || upd.status) return true;
        if (edit.isCustom === true) return true;
        return false;
      };
    },
    reasonModalTitle() {
      if (this.pendingAction === 'approve') return 'Approve Change';
      if (this.pendingAction === 'reject') return 'Reject Change';
      return 'Enter Reason for Change';
    },
    filteredBoardsForEmployee() {
      if (!this.selectedEmployee || !this.membersLoaded) return [];

      let empUsername = "";
      if (this.selectedEmployee.uid === this.user.uid) {

        empUsername = this.selectedEmployeeTrelloUsername.trim().toLowerCase();
      }
      else {
        if (!this.selectedEmployee.trelloUsername) {
          Swal("Error", "Employee Trello username is missing.", "error");
          return [];
        }
        empUsername = this.selectedEmployee.trelloUsername.trim().toLowerCase();
  }
  const boards = this.boards
    .map(board => {
      const members = this.boardMemberCache[board.id] || [];
      const isMember = Array.isArray(members) && members.some(m => 
        m && m.username && m.username.trim().toLowerCase() === empUsername
        );
      return isMember ? { name: board.name, id: board.id } : null;
    })
    .filter(Boolean);

      return [
        { name: "All Projects", id: "" },
        ...boards
      ];
},

    filteredPerformanceData() {
      const finalCards = this.doneCards.map((card, index) => ({
        id: card.id || card.cardId,
        sno: index + 1,
        details: Array.isArray(card.details) ? card.details : (card.updatedData && Array.isArray(card.updatedData.details)) ? card.updatedData.details : [],
        taskName: card.name || 'Untitled',
        type: card.type || null,
        project: card.boardName || this.selectedBoardName || null,
        durationSpent: formatDuration(parseDurationString(card.durationInProgress)),
        movedToDone: formatMovedToDone(card.movedDate, card.movedTime),
        movedDate: card.movedDate || null,
        movedTime: card.movedTime || null,
        reopened: (card.status === "rejected") ? (card.originalreopenCount || 0) : (card.reopenCount || 0), 
        deadlineMissed: card.deadlineMissedCount || 0,
        score: card.score !== undefined ? card.score : 0,
        rating: card.rating !== undefined ? card.rating : 0,
        link: card.link,
        scoreReason: card.scoreReason || null,
        isCustom: card.isCustom || false,      
        board: card.boardName || this.selectedBoardName ,
        member: this.selectedMemberName || "Unknown",
        reopenHistory: card.reopenHistory || [],
        status:card.status,
        ticketStatus : card.ticketStatus || null,
        originalreopenCount: card.originalreopenCount !== undefined && card.originalreopenCount
      }));
      return finalCards;
    },

    tableTotals() {
      const totals = { reopened: 0, deadlineMissed: 0, score: 0 };
      this.doneCards.forEach(c => {
        if (c.ticketStatus === 'pending') return;
        totals.reopened += (c.status!=="pending" && c.status!=="rejected") 
          ? Number(c.reopenCount || 0) 
          : Number(c.originalreopenCount || 0);
        totals.score += Number(c.score || 0);
        totals.deadlineMissed += Number(c.deadlineMissedCount || 0);
      });
      return totals;
    },

    summaryCards() {
      if (this.loading || this.error || this.noMemberFound || !this.doneCards.length) return [];
      const rawScore = this.tableTotals.score;
const reopenDeduction = this.reopenLimit && this.reopenScore
    ? (this.tableTotals.reopened >= this.reopenLimit ? this.reopenScore : 0)
    : (this.reopenEvery && this.reopenScore ? Math.floor(this.tableTotals.reopened / this.reopenEvery) * this.reopenScore : 0);
const deadlineDeduction = this.deadlineLimit && this.deadlineScore
    ? (this.tableTotals.deadlineMissed >= this.deadlineLimit ? this.deadlineScore : 0)
    : (this.deadlineEvery && this.deadlineScore ? Math.floor(this.tableTotals.deadlineMissed / this.deadlineEvery) * this.deadlineScore : 0);
      const adjustedScore = rawScore + reopenDeduction + deadlineDeduction;
      const scoreByType = {};

      this.doneCards.forEach(card => {
        if (card.ticketStatus === 'pending') return;   
        const type = card.type || 'Ticket';
        scoreByType[type] = (scoreByType[type] || 0) + Number(card.score || 0);
      });
      const sortedTypes = Object.entries(scoreByType)
        .sort(([,a], [,b]) => b - a)
        .map(([type, sum]) => ({ type, sum }));
      return [
        { value: this.doneCards.length,          label: "Total Items",     color: "#007bff" },
        { value: this.tableTotals.reopened,      label: "Total Reopens",   color: "#ff4d4d" },
        { value: this.tableTotals.deadlineMissed,label: "Total Deadlines Missed", color: "#ff8c00" },
        { value: adjustedScore.toFixed(1), label: "Total Score", color: "#00c7c7", hasTooltip: true, grossScore: rawScore, reopenDeduction: (this.reopenEvery || this.reopenLimit) ? reopenDeduction : null, deadlineDeduction: (this.deadlineEvery || this.deadlineLimit) ? deadlineDeduction : null, typeBreakdown: sortedTypes }
      ];
    },
  },
  watch: {
    effectiveLocked(newVal, oldVal) {
      if (
        newVal === true &&
        oldVal === false &&
        !this.lockData.locked &&
        this.lockData.scheduledLockTime &&
        !this.scheduledLockSaveFired &&
        this.showLockBar &&
        this.selectedEmployee &&
        this.selectedMonth &&
        this.selectedYear
      ) {
        this.scheduledLockSaveFired = true;
        this.onScheduledLockElapsed();
      }
    },
  },
  async created() {
    const user = this.$store.state.auth.user;
    this.isAdmin = user && user.role === "admin";

    const allUsers = this.$store.state.auth.allUsers || [];
    const companyUserIds = (this.$store.state.auth.company.users || []).map(u => u.uid);
    this.employeeList = allUsers.filter(u => companyUserIds.includes(u.uid));

    const now = new Date();
    this.selectedMonth = this.months[now.getMonth()];
    this.selectedYear = now.getFullYear().toString();

    this.selectedEmployee = this.isAdmin
      ? this.employeeList.find(e => e.isActive) || this.employeeList[0]
      : this.employeeList.find(u => u.uid === user.uid);

    if(!this.isAdmin ){
       this.loading = true;
    } 
    await this.fetchBoards();
    if (this.boards.length) await this.fetchAllBoardMembers();
    this.membersLoaded = true;

    await this.loadFirebaseEdits();

    if (!this.isAdmin && !this.autoLoadDone) await this.triggerSearch();
    await this.fetchCriteria();
    this.loading = false;
  },
  mounted() {
    this.interval = setInterval(this.updateCountdown, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
   async fetchLockStatus() {
      if (!this.selectedMonth || !this.selectedYear) return; 
      this.lockData = await firebase.fetchPerformanceLock(this.selectedYear, this.selectedMonth);
    },
    formatDate(ts) {
      return new Date(ts).toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'});
    },
    formatTime(ts) {
      return new Date(ts).toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit', hour12: true});
    },
    updateCountdown() {
      this.currentTime = Date.now();
      if (!this.isScheduled) {
        this.timeRemaining = '';
        return;
      }
      const diff = this.lockData.scheduledLockTime - this.currentTime;
      if (diff <= 0) {
        this.timeRemaining = '00:00:00';
        return;
      }
      const h = Math.floor(diff / 3600000).toString().padStart(2, '0');
      const m = Math.floor((diff % 3600000) / 60000).toString().padStart(2, '0');
      const s = Math.floor((diff % 60000) / 1000).toString().padStart(2, '0');
      this.timeRemaining = `${h}:${m}:${s}`;
    },

    async onScheduledLockElapsed() {
      try {
        await firebase.savePerformanceLock(this.selectedYear, this.selectedMonth, true, null);
        this.lockData.locked = true;
        if (
          !this.lockData.userIds ||
          this.lockData.userIds[this.selectedEmployee.uid] !== true
        ) {
          await this.savePerformanceTableAndFlag();
        }
      } catch (e) {
        console.error('onScheduledLockElapsed error:', e);
        Swal('Error', e.message || 'Failed to apply scheduled lock.', 'error');
      }
    },

    openEndScheduleModal() {
      this.isEndScheduleModalOpen = true;
    },
    async confirmEndSchedule() {
      this.isLoading = true;
      await this.saveLock(false, null);
      swal('Success', 'Schedule ended successfully.', 'success');
      this.isLoading = false;
      this.isEndScheduleModalOpen = false;
    },
    async onLockButtonClick() {
      if (this.effectiveLocked) {
        this.isUnLockModalOpen = true;
        return;
      }
        if (this.isScheduled && this.lockData.scheduledLockTime) {
          const scheduled = new Date(this.lockData.scheduledLockTime);
          this.lockDate = scheduled.toISOString().slice(0, 10);
          this.lockTime = scheduled.toTimeString().slice(0, 5);
        } else {
          this.lockDate = '';
          this.lockTime = '';
        }
        this.isLockModalOpen = true;
    },
    async scheduleLock() {
      if (!this.lockDate || !this.lockTime) {
        Swal('Error', 'Please select date and time.', 'error');
        return;
      }
      const newTs = new Date(`${this.lockDate}T${this.lockTime}:00`).getTime();
      if (newTs <= Date.now()) {
        Swal('Error', 'Please select a future date and time.', 'error');
        return;
      }
      if (this.isScheduled && this.lockData.scheduledLockTime === newTs) {
        Swal('Info', 'No changes were made to the schedule.', 'info');
        return;
      }
      this.scheduledloading = true;
      this.scheduledLockSaveFired = false;
      await this.saveLock(false, newTs);
      swal('Success', 'Lock scheduled successfully.', 'success');
      this.scheduledloading = false;
      this.isLockModalOpen = false;
    },
    async lockNow() {
      this.isLoading = true; 
      await this.saveLock(true, null);
      this.isLoading = false;
      this.isLockModalOpen = false;
    },
    async confirmUnLock() {
       this.isLoading = true; 
       this.scheduledLockSaveFired = false;
      await this.saveLock(false, null);
      swal('Success', 'Unlocked successfully.', 'success');
      this.isLoading = false;
      this.isUnLockModalOpen = false;
    },
    async saveLock(locked, scheduledTime) {
      
      try {
        if (scheduledTime !== null) {
          this.lockData.scheduledLockTime = scheduledTime;
        } else {
          this.lockData.scheduledLockTime = null;
        }
        await firebase.savePerformanceLock(this.selectedYear, this.selectedMonth, locked, scheduledTime);
        this.lockData.locked = locked;
        let action = '';
        let descExtra = '';
        if (locked) {
          action = 'Locked';
        } else if (scheduledTime) {
          action = 'Scheduled Lock';
          descExtra = ` on ${this.formatDate(scheduledTime)} at ${this.formatTime(scheduledTime)}`;
        } else {
          action = 'Unlocked';
        }
        const commonFields = {
          description: `${this.$store.state.auth.user.username} ${action.toLowerCase()} performance modifications for All employees for ${this.selectedMonth} ${this.selectedYear}${descExtra}`,
          activityName: `${this.$store.state.auth.user.username} ${action === "Scheduled Lock" ? "scheduled" : action.toLowerCase()} Performance ${action === "Scheduled Lock" ? "Lock for" : "for"} ${this.selectedMonth} ${this.selectedYear}`,
        }
        const adminActivity = {
          adminId: this.$store.state.auth.user.uid,
          activityOnUser: "All Employees",
          activityOnUserName: "All Employees",
          activityByUserName: this.$store.state.auth.user.username || 'Admin',
          action: action + ' Performance',
          activityTitle: action + ' performance',
          activityDescription: commonFields.description,
          activityName: commonFields.activityName,
          type: 'performance_lock',
          timestamp: new Date().toLocaleString('en-PK'),
          month: this.selectedMonth,
          year: this.selectedYear,
        };
        await logAdminActivity(adminActivity);

        await handleActivityNotification(
          {
            type: "performance_lock_unlock",
            activityDescription: commonFields.description,
            activityName: commonFields.activityName,
            activityByUserName: this.user.username,
            action: action,
          },
          this.$store.state.auth,
          this.user.uid
        );
        if (locked) {
          await this.savePerformanceTableAndFlag();
          Swal('Success', `${this.hasUnmatchedTrelloCards ? 'Locked and saved' : 'Locked'} successfully.`, 'success');
        } else {
          Swal('Success', `${action === 'Scheduled Lock' ? 'Lock scheduled' : 'Unlocked'} successfully.`, 'success');
        }
      } catch (e) {
        Swal('Error', e.message || 'Failed to save lock status.', 'error');
      }
    },
    async fetchCriteria() {
      try {
        const list = await firebase.getAllPerformanceCriteria();
        this.criteriaList = list || [];
        const ticketCrit = this.criteriaList.find(c => c.type === 'Ticket');
        if (ticketCrit && ticketCrit.rules.penalties) {
          this.reopenEvery = ticketCrit.rules.penalties.reopens.every || null;
          this.reopenScore = ticketCrit.rules.penalties.reopens.score || null;
          this.deadlineEvery = ticketCrit.rules.penalties.deadlineMissed.every || null;
          this.deadlineScore = ticketCrit.rules.penalties.deadlineMissed.score || null;
          this.reopenLimit = ticketCrit.rules.penalties.reopens.limit || null;
          this.deadlineLimit = ticketCrit.rules.penalties.deadlineMissed.limit || null;
        }
      } catch (err) {
        console.error("Failed to fetch criteria:", err);
      }
    },
    handleModalClose(newVal) {
      this.isAddModalOpen = newVal;
      if (!newVal) {
        this.selectedItem = null;
      }
    },
    showDetails(id) { this.$set(this.visibleDetails, id, true); },
    hideDetails(id) { this.$set(this.visibleDetails, id, false); },
    onEditClick(item) {
      this.selectedItem = item;
      this.isAddModalOpen = true;
    },
    openLogoutModal() {
      this.isLogoutModalOpen = true;
    },
    confirmLogout() {
      this.$emit("logoutFromTrello");  
      this.isLogoutModalOpen = false;
    },
    async onItemAdded({cardId, payload}) {
      this.isAddModalOpen = false;
      this.selectedItem = null;

      const newEdited = { ...payload, cardId, isCustom: true };
      this.$set(this.editedCards, cardId, newEdited);

      let mergedCard = { ...newEdited };
      mergedCard.id = cardId;
      mergedCard.name = payload.name;
      mergedCard.durationInProgress = payload.durationInProgress;
      mergedCard.reopenCount = payload.reopenCount || 0;
      mergedCard.deadlineMissedCount = payload.deadlineMissedCount || 0;
      mergedCard.score = payload.score || 0;
      mergedCard.rating = payload.rating || 0;
      mergedCard.link = payload.link || '#';
      mergedCard.boardName = payload.boardName || 'Custom';
      mergedCard.type = payload.type;
      mergedCard.scoreReason = payload.scoreReason;
      mergedCard.isCustom = true;
      mergedCard.ticketStatus = payload.ticketStatus;
      mergedCard.status = 'approved'; // Adjust based on logic
      this.doneCards.push(mergedCard);
    },
    async onItemUpdated(editPayload) {
      this.isAddModalOpen = false;
      this.selectedItem = null;

      const cardId = editPayload.cardId;
      this.$set(this.editedCards, cardId, editPayload);

      const card = editPayload;
      let mergedCard;
        mergedCard = { 
          ...card.originalData, 
          id: card.cardId, 
          boardName: card.board || card.originalData.boardName || 'Unknown', 
          details: card.updatedData.details || card.originalData.details || '', 
          type: card.type || 'custom' 
        };
        mergedCard.customEdit = card.customEdit;
        mergedCard.isCustom = card.isCustom;
        mergedCard.type = card.type;
        mergedCard.scoreReason = card.scoreReason;
        mergedCard.ticketStatus = card.ticketStatus;
        mergedCard.movedDate = card.movedDate || card.originalData.movedDate || null;
        mergedCard.movedTime = card.movedTime || card.originalData.movedTime || null;

        const upd = card.updatedData || {};
        mergedCard.status = upd.status || 'approved';
        if (upd.reopened !== undefined) mergedCard.reopenCount = upd.reopened;
        if (upd.score !== undefined) mergedCard.score = upd.score;
        if (upd.rating !== undefined) mergedCard.rating = upd.rating;
        if (upd.name !== undefined) mergedCard.name = upd.name;
        if (upd.durationInProgress !== undefined) mergedCard.durationInProgress = upd.durationInProgress;
        if (upd.deadlineMissedCount !== undefined) mergedCard.deadlineMissedCount = upd.deadlineMissedCount;

      const index = this.doneCards.findIndex(c => c.id === cardId);
      if (index > -1) {
        this.$set(this.doneCards, index, mergedCard);
      } else {
        this.doneCards.push(mergedCard);
      }
    },
    openMapPopup(activity) {
      const lat = activity.latitude || activity.timeIn.latitude || activity.timeOut.latitude;
      const lng = activity.longitude || activity.timeIn.longitude || activity.timeOut.longitude;

      if (!lat || !lng) {
        alert("No location data available for this activity.");
        return;
      }

      this.currentCoordinates = { latitude: lat, longitude: lng };
      this.mapPopup = true;
      this.$nextTick(() => {
        const mapEl = document.getElementById('mapActivity');
        if (!mapEl) return;
        if (mapEl._leaflet_id) {
          mapEl._leaflet_id = null;
        }

        const map = L.map('mapActivity').setView([lat, lng], 16);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(map);

        L.marker([lat, lng])
          .addTo(map)
          .bindPopup(`
            <b>Location</b><br>
            ${lat.toFixed(6)}, ${lng.toFixed(6)}<br>
            <small>${activity.activityByUserName || 'Admin'} • ${activity.timestamp || 'Just now'}</small>
          `)
          .openPopup();
        const googleLink = `https://www.google.com/maps?q=${lat},${lng}`;
        L.DomUtil.create('div', 'map-link', map.getContainer()).innerHTML = `
          <a href="${googleLink}" target="_blank" style="color:#1a73e8; font-size:12px;">
            Open in Google Maps
          </a>
        `;
      });
    },
    async onHistoryClick(item) {
      this.isHistoryModalOpen = true;

      try {
        this.performanceActivity = await firebaseDB.fetchPerformanceActivities(
          this.selectedMonth,
          this.selectedYear,
          this.selectedEmployee.uid,
          item.id   // cardId
        );
      } catch (err) {
        console.error("Failed to load history:", err);
        Swal("Error", "Failed to load activity history", "error");
        this.performanceActivity = [];
  } finally {
    this.loading = false;
      }
    },
    onDeleteClick(item) {
      this.cardToDelete = item.id;
      this.isDeleteModalOpen = true;
    },
    onApproveClick(item) {
      this.cardToApprove = item;
      this.isApproveModalOpen = true;
    },
    openConfirm(action, card, field) {
      this.pendingAction = action;
      this.pendingCardId = card.id;
      this.pendingField = field;
      this.changeInfo = { field,original: card.originalreopenCount != null ? card.originalreopenCount : 0,
        new: card.reopened != null ? card.reopened : 0 
      };
      this.reason = card.reopenReason || card.scoreReason || '';
      this.showReasonModal = true;
    },
    async handleReasonSubmit() {
        if (this.pendingAction === 'approve') {
        await this.approveEdit(this.pendingCardId, this.pendingField);
      } else if (this.pendingAction === 'reject') {
        await this.rejectEdit(this.pendingCardId, this.pendingField);
      } else {
        await this.saveChange();
      }
    },
    delay(ms) { return new Promise(r => setTimeout(r, ms)); },

    async safeTrelloFetch(url) {
      try {
        const res = await fetch(url);
        if (res.status === 429) {
          await this.delay(10000);
          throw new Error("Rate limit");
        }
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
      } catch (err) {
        console.error("Fetch error:", err);
        return [];
      }
    },

    truncateText(text, max = 20) {
      if (text === null || text === undefined) return '';
      const str = String(text);
      return str.length > max
        ? str.slice(0, max) + '...'
        : str;
    },

    fetchBoards() {
      return fetch(`https://api.trello.com/1/members/me/boards?key=${this.TRELLO_API_KEY}&token=${this.TRELLO_TOKEN}`)
        .then(r => r.json())
        .then(data => { this.boards = data; })
        .catch(err => { this.error = "Failed to fetch boards."; throw err; });
    },

    fetchAllBoardMembers() {
      const promises = this.boards.map(board =>
        fetch(`https://api.trello.com/1/boards/${board.id}/members?key=${this.TRELLO_API_KEY}&token=${this.TRELLO_TOKEN}`)
          .then(r => r.json())
          .then(m => { this.boardMemberCache[board.id] = m; })
          .catch(err => {
            console.warn("Failed to fetch members for board:", board.id, err);
            this.boardMemberCache[board.id] = [];
          })
      );
      return Promise.all(promises);
    },

    onBoardSelect(board) {
      if (!board.id) {
        this.selectedBoardId = "";
        this.selectedBoardName = "";
        return;
      }

      this.selectedBoardId = board.id;
      this.selectedBoardName = board.name;
    },

    onEmployeeSelect(emp) {
      this.selectedEmployee = emp;
      this.selectedBoardId = "";
      this.selectedBoardName = "";
      this.noMemberFound = false;
      this.hasSearched = false;
      this.showLockBar = false;
    },

    onMonthSelect(m) {
    this.selectedMonth = m.name;
    this.showLockBar = false;
  },
  onYearSelect(y) {
    this.selectedYear = y.name;
    this.showLockBar = false;
  },

    updateDateRange() {
      if (!this.selectedMonth || !this.selectedYear) return;
      const mIdx = this.months.indexOf(this.selectedMonth);
      const y = parseInt(this.selectedYear);
      this.startDate = new Date(y, mIdx, 1, 0, 0, 0, 0).toISOString();
      this.endDate = new Date(y, mIdx + 1, 0, 23, 59, 59, 999).toISOString();
    },

   async loadFirebaseEdits() {
      if (!this.selectedEmployee || !this.selectedMonth || !this.selectedYear) return;
      const filters = {
        month: this.selectedMonth,
        year: this.selectedYear,
        userId: this.selectedEmployee.uid,
        boardId: this.selectedBoardId || null
      };
      const result = await firebase.fetchEditedCards(filters);
      this.editedCards = result || {};
      this.customCards = Object.values(this.editedCards).filter(
        card => card.isCustom === true
      );
    },
    openSaveConfirmModal() {
      this.isSaveConfirmModalOpen = true;
    },

    async savePerformanceTableAndFlag() {
      if (!this.selectedEmployee || !this.doneCards.length) return;

      this.isLoading = true;
      try {
        await this.loadFirebaseEdits();
        const existingCardIds = new Set(
          Object.values(this.editedCards || {})
            .map(card => card.cardId || card.id)
            .filter(Boolean)
        );
        const cardsToSave = this.doneCards.filter(card => {
          const cardId = card.cardId || card.id;
          return cardId && !existingCardIds.has(cardId);
        });
        await firebase.savePerformanceUserId(
          this.selectedYear,
          this.selectedMonth,
          this.selectedEmployee.uid
        );
        this.hasUnmatchedTrelloCards = cardsToSave.length > 0 ? true : false
        if (cardsToSave.length === 0) return
        const preparedCards = cardsToSave.map(card => ({
          ...card,
          month: this.selectedMonth,
          year: this.selectedYear,
          user: this.selectedEmployee.uid,
          isSnapshot: true,
          snapshotSavedAt: new Date().toLocaleString('en-PK'),
          cardId: card.cardId || card.id,
          id: card.cardId || card.id,
          boardName: card.boardName || card.board || this.selectedBoardName || "Unknown",
          ticketStatus: card.ticketStatus || "approved",
          status: card.status || "approved",
          filterKey: `${this.selectedYear}-${this.selectedMonth}-${this.selectedEmployee.uid}-${card.boardId || card.board || 'null'}`,
          reopenCount: card.reopenCount ? card.reopenCount : (card.reopens ? card.reopens : null),
          originalreopenCount: card.originalreopenCount ? card.originalreopenCount : null,
          deadlineMissedCount: card.deadlineMissedCount ? card.deadlineMissedCount : (card.deadlineMissed ? card.deadlineMissed : null),
          durationInProgress: card.durationInProgress ? card.durationInProgress : (card.duration ? card.duration : null),
          originalDurationInProgress: card.originalDurationInProgress ? card.originalDurationInProgress : null,
          type: card.type || "Ticket",
        }));
        await firebase.savePerformanceSnapshot(
          preparedCards
        );
       const adminActivity = {
          adminId: this.$store.state.auth.user.uid,
          activityOnUser: this.selectedEmployee.uid || this.selectedEmployee.email || 'Unknown Employee',
          activityOnUserName: this.selectedEmployee.username || this.selectedEmployee.email || 'Unknown Employee',
          activityByUserName: this.$store.state.auth.user.username || 'Admin',
          action: 'Saved Performance Snapshot',
          activityTitle: 'Saved performance snapshot for ' + (this.selectedBoardName || 'all boards'),
          activityDescription: `${this.isAdmin ? this.$store.state.auth.user.username + ' saved' : 'Saved'} performance of ${this.selectedEmployee.username} for ${this.selectedMonth} ${this.selectedYear}`,
          activityName: `${this.isAdmin ? this.$store.state.auth.user.username + ' saved' : 'Saved'} performance of ${this.selectedEmployee.username} for ${this.selectedMonth} ${this.selectedYear}`,
          type: 'performance_snapshot',
          timestamp: new Date().toLocaleString('en-PK'),
          month: this.selectedMonth,
          year: this.selectedYear,
        };
        await logAdminActivity(adminActivity);

      } catch (e) {
        console.error("Save snapshot failed:", e);
        Swal('Error', 'Failed to save snapshot data.', 'error');
      } finally {
        this.isLoading = false;
      }
    },
    normalizePerformanceCard(card) {
      if (!card) return {};
      const original = card.originalData || {};
      const updated = card.updatedData || {};
      return {
        ...card,
        id: card.cardId || card.id,
        name: card.name || updated.name || original.name || 'Untitled',
        boardName: card.boardName || card.board || original.boardName || this.selectedBoardName || 'Unknown',
        reopenCount: card.reopenCount != null ? card.reopenCount : (updated.reopened != null ? updated.reopened : null),
        originalreopenCount: card.originalreopenCount != null ? card.originalreopenCount : (original.reopenCount != null ? original.reopenCount : null),
        score: card.score != null ? card.score : (updated.score != null ? updated.score : null),
        link: card.link || original.link || updated.link || '#',
        movedDate: card.movedDate || original.movedDate || null,
        movedTime: card.movedTime || original.movedTime || null,
        deadlineMissedCount: card.deadlineMissedCount != null ? card.deadlineMissedCount : (updated.deadlineMissedCount != null ? updated.deadlineMissedCount : null),
        durationInProgress: card.durationInProgress || updated.durationInProgress ||  original.durationInProgress,
        status: card.status || updated.status || 'approved',
        ticketStatus: card.ticketStatus || 'approved',
        isCustom: !!card.isCustom,
        type: card.type || null,
        reopenHistory: Array.isArray(card.reopenHistory) ? card.reopenHistory : []
      };
    },
    async mergeWithFirebase() {
      if (!this.doneCards.length && !this.customCards.length ) return;
      await this.loadFirebaseEdits();
      this.customCards = this.customCards.filter(card => card.isSnapshot !== true);
      const mergedCustom = this.customCards.map(card => {
        if (card.customEdit !== true) return card;
        const mergedCard = { ...card.originalData, id: card.cardId, boardName: card.board || card.originalData.boardName || 'Unknown', details: card.updatedData.details || card.originalData.details || '', type: card.type || 'custom',
          customEdit: card.customEdit , isCustom:card.isCustom, type: card.type, scoreReason: card.reason, ticketStatus: card.ticketStatus
         };
        const upd = card.updatedData || {};
        mergedCard.status = upd.status || 'approved';

        if (upd.reopened !== undefined) mergedCard.reopenCount = upd.reopened;
        if (upd.score !== undefined) mergedCard.score = upd.score;
        if (card.originalData.reopenCount !== undefined && (mergedCard.status === 'pending' || mergedCard.status === 'rejected')) mergedCard.originalreopenCount = card.originalData.reopenCount;
        if (upd.status !== undefined) mergedCard.status = upd.status;
        if (upd.name !== undefined) mergedCard.name = upd.name;
        if (upd.durationInProgress !== undefined)
          mergedCard.durationInProgress = upd.durationInProgress;
        if (upd.deadlineMissedCount !== undefined)
          mergedCard.deadlineMissedCount = upd.deadlineMissedCount;
        if (upd.scoreReason !== undefined)
          mergedCard.scoreReason = upd.scoreReason;

        return mergedCard;
      });
      const merged = this.doneCards.map(card => {
        const fb = this.editedCards[card.id];
        if (!fb) return card;

        const mergedCard = { ...card };
        const upd = fb.updatedData || {};
        if (upd.reopened !== undefined) mergedCard.reopenCount = upd.reopened;
        if (upd.score !== undefined) mergedCard.score = upd.score;
        if (upd.status !== undefined) mergedCard.status = upd.status;
        if(upd.name !== undefined) mergedCard.name = upd.name;
        if(upd.durationInProgress !== undefined) mergedCard.durationInProgress = upd.durationInProgress;
        if(upd.deadlineMissedCount !== undefined) mergedCard.deadlineMissedCount = upd.deadlineMissedCount;
        if (fb.originalData && fb.originalData.reopenCount !== undefined) {
          mergedCard.originalreopenCount = fb.originalData.reopenCount;
        }
        if (upd.scoreReason !== undefined) mergedCard.scoreReason = upd.scoreReason;

        return mergedCard;
      });
      this.doneCards = [...merged, ...mergedCustom];
    },

    async triggerSearch() {
      this.loading = true;
      this.showLockBar = false
      if (!this.selectedEmployee || !this.selectedMonth || !this.selectedYear) {
        this.error = "Select employee, month, and year.";
        this.loading = false;
        return;
      }
      await this.fetchLockStatus();
      await this.fetchCriteria();
      this.updateDateRange();
      this.doneCards = [];
      this.error = null;
      this.hasSearched = true;

      const empName = this.selectedEmployee.username.trim().toLowerCase();
      const boardsToCheck = this.selectedBoardId
        ? [{ id: this.selectedBoardId, name: this.selectedBoardName }]
        : this.filteredBoardsForEmployee;

      if (!boardsToCheck.length) {
        this.noMemberFound = true;
        this.loading = false;
        return;
      }
      const isLockedAndSaved =
        this.effectiveLocked &&
        this.lockData.userIds &&
        this.lockData.userIds[this.selectedEmployee.uid] === true;

      if (isLockedAndSaved) {
        await this.loadFirebaseEdits();
        const finalCards = sortByMovedDate(
          Object.values(this.editedCards || {}).map(card =>
            this.normalizePerformanceCard(card)
          )
        );
        this.doneCards = finalCards;
      }
      else {
      const allDoneCards = [];

      const processBoard = async (board) => {
        const members = this.boardMemberCache[board.id] || [];
        const member = Array.isArray(members) && members.find(m =>
          m && m.fullName && m.fullName.trim().toLowerCase().includes(empName)
        );
        if (!member) return;

        this.selectedMemberId = member.id;
        this.selectedMemberName = member.fullName;

        let lists = [];
        try {
          const resp = await fetch(`https://api.trello.com/1/boards/${board.id}/lists?key=${this.TRELLO_API_KEY}&token=${this.TRELLO_TOKEN}`);
          if (resp.ok) lists = await resp.json();
        } catch (e) {
          console.warn("Failed to fetch lists for board:", board.id, e);
        }

        const doneList = Array.isArray(lists)
          ? lists.find(l => l && l.name && typeof l.name === 'string' && l.name.toLowerCase().includes("done"))
          : null;

        const reopenList = Array.isArray(lists)
          ? lists.find(l => l && l.name && typeof l.name === 'string' && l.name.toLowerCase().includes("reopen"))
          : null;

        if (!doneList) return;

        let cards = [];
        try {
          const resp = await fetch(`https://api.trello.com/1/lists/${doneList.id}/cards?key=${this.TRELLO_API_KEY}&token=${this.TRELLO_TOKEN}`);
          if (resp.ok) cards = await resp.json();
        } catch (e) {
          return;
        }

        for (const card of (cards || [])) {
          if (!card.idMembers || !card.idMembers.includes(member.id)) continue;

          const actions = await this.safeTrelloFetch(
            `https://api.trello.com/1/cards/${card.id}/actions?key=${this.TRELLO_API_KEY}&token=${this.TRELLO_TOKEN}&filter=updateCard:idList,commentCard`
          );
          const safeActions = Array.isArray(actions) ? actions : [];

          const moveToDone = safeActions.find(a =>
            a.type === "updateCard" && a.data && a.data.listAfter && a.data.listAfter.id === doneList.id
          );
          if (!moveToDone) continue;

          const moveDate = new Date(moveToDone.date);
          const moveISO = moveDate.toISOString();
          if (moveISO < this.startDate || moveISO > this.endDate) continue;

          let total = 0;
          const inProgress = safeActions
            .filter(a => a.data && a.data.listAfter && a.data.listAfter.name && a.data.listAfter.name.toLowerCase().includes("in progress"))
            .reverse();
          const outProgress = safeActions
            .filter(a => a.data && a.data.listBefore && a.data.listBefore.name && a.data.listBefore.name.toLowerCase().includes("in progress"))
            .reverse();

          for (let j = 0; j < inProgress.length; j++) {
            const entry = new Date(inProgress[j].date);
            const exit = outProgress.find(a => new Date(a.date) > entry);
            if (exit) total += new Date(exit.date) - entry;
          }

          let dur = "N/A", sc = 0;
          if (total > 0) {
            const hrs = Math.floor(total / (1000 * 60 * 60));
            const mins = Math.floor((total % (1000 * 60 * 60)) / (1000 * 60));
            dur = `${hrs} hrs ${mins} mins`;
            const totalHours = total / (1000 * 60 * 60);
            const ticketCriteria = this.criteriaList.filter(c => c.type === 'Ticket').sort((a,b) => a.rules.duration.min - b.rules.duration.min);
             (!this.criteriaList.length || !ticketCriteria.length) && swal("Warning", "No performance or ticket criteria found. Please add criteria to calculate scores.", "warning");
            const matchingCrit = ticketCriteria.find(crit => totalHours >= crit.rules.duration.min && totalHours < crit.rules.duration.max);
            const lastCrit = ticketCriteria[ticketCriteria.length-1];
           if(!matchingCrit && ticketCriteria.length && lastCrit && totalHours <= lastCrit.rules.duration.min){
             swal("Warning", `Some tickets do not match any criteria. e.g : ${totalHours.toFixed(2)} hrs. \n These tickets will be scored 0. Needs to update ticket criteria.`, "warning");
           }
            sc = matchingCrit ? matchingCrit.score : (lastCrit && lastCrit.length >= 3 && totalHours >= lastCrit.rules.duration.min ? lastCrit.score : 0);
          }

          const cd = {
            id: card.id,
            name: card.name || "Untitled Card",
            link: card.shortUrl || "#",
            movedDate: moveDate.toLocaleDateString(),
            movedTime: moveDate.toLocaleTimeString(),
            durationInProgress: dur,
            deadlineMissedCount: safeActions.filter(a =>
              a.type === "commentCard" && a.data && a.data.text && a.data.text.includes("Deadline missed an hour ago!")
            ).length,
            score: sc,
            reopenCount: 0,
            reopenHistory: [],
            boardName: board.name
          };

          if (reopenList) {
            const reopenActs = safeActions.filter(a =>
              a.data && a.data.listAfter && a.data.listAfter.id === reopenList.id
            );
            if (reopenActs.length > 0) {
              cd.reopenCount = reopenActs.length;
              cd.reopenHistory = reopenActs.map(a => ({
                moveDate: new Date(a.date).toLocaleString(),
                listName: (a.data.listAfter && a.data.listAfter.name) || "Reopen"
              }));
            }
          }

          allDoneCards.push(cd);
          await this.delay(100);
        }
      };

      await Promise.all(boardsToCheck.map(processBoard));
      this.doneCards = allDoneCards;

      await this.mergeWithFirebase();
    }
      this.showLockBar = true
      this.loading = false;
      this.autoLoadDone = true;
      if (this.effectiveLocked && (!this.lockData.userIds || this.lockData.userIds[this.selectedEmployee.uid] !== true)) {
        await this.savePerformanceTableAndFlag();
      }
    },

    openDeleteModal(cardId) {
      this.cardToDelete = cardId;
      this.isDeleteModalOpen = true;
    },
    closeHistoryModal() {
       this.isHistoryModalOpen = false;
       this.performanceActivity = [];
     },
    handleRowClick(item) { this.selectedItem = item; this.isModalOpen = true; },
    canEdit(field) {
      if (field === 'score') return this.isAdmin;
      return true;
    },
    isEditing(key, field) {
      return this.editing[`${key}-${field}`];
    },
    startEdit(key, field, value) {
      this.$set(this.editing, `${key}-${field}`, true);
      this.$set(this.tempValues, `${key}-${field}`, value);
    },
    cancelEdit(key, field) {
      this.$set(this.editing, `${key}-${field}`, false);
    },
    confirmEdit(item, field, original, reason) {
      this.tableData = item;
      const key = item.id;
      const newVal = this.tempValues[`${key}-${field}`];
      if (newVal == original) {
        this.cancelEdit(key, field);
        return;
      }
      this.changeInfo = { field, original, new: newVal, cardId: key };
      this.reason = reason || '';
      this.showReasonModal = true;
    },
    async confirmDelete() {
      if (!this.cardToDelete) return;
      this.isLoading = true;
      const action = "Deleted";
      const cardId = this.cardToDelete;
      const trelloCard = this.doneCards.find(c => c.id === cardId);
      if (!trelloCard) return;
      const commonFields = {
        description: `${this.$store.state.auth.user.email} ${action.toLowerCase()} ${this.selectedEmployee.email}'s card "${trelloCard.name}" ${this.reason ? '. Reason: ' + this.reason : ''}` ,
        activityName: `${this.$store.state.auth.user.username} ${(this.isAdmin && trelloCard.ticketStatus === 'pending') ? 'rejected' : action.toLowerCase()} ${this.isAdmin ? `${this.selectedEmployee.username}'s` : ''} card "${trelloCard.name} " for ${this.selectedMonth} ${this.selectedYear}` ,
      }
      const adminActivity = {
        adminId: this.$store.state.auth.user.uid,
        activityOnUser: this.selectedEmployee.uid,
        activityOnUserName: this.selectedEmployee.username,
        activityByUserName: this.$store.state.auth.user.username || 'Admin',
        action: action,
        activityTitle: `deleted card edit`,
        activityDescription:  commonFields.description,
        activityName: commonFields.activityName,
        type: 'performance_edit',
        timestamp: new Date().toLocaleString('en-PK'),
        cardId: cardId,
        cardName: trelloCard.name,
        month: this.selectedMonth,
        year: this.selectedYear,
      };
      try {
        await firebase.deleteEditedCard(this.cardToDelete);
        await logAdminActivity(adminActivity);
        this.doneCards = this.doneCards.filter(c => c.id !== this.cardToDelete);
        this.$delete(this.editedCards, this.cardToDelete);

        if (trelloCard.ticketStatus !== 'pending' || this.isAdmin) {
          const { uid, username } = this.$store.state.auth.user;
          await handleActivityNotification(
            {
              type: "performance_edit",
              activityDescription: commonFields.description,
              activityOnUser: this.selectedEmployee.uid,
              activityOnUserName: this.selectedEmployee.username,
              activityByUserName: username,
              action: action,
              cardName: trelloCard.taskName,
              activityName: commonFields.activityName,
              isAdmin: this.isAdmin
            },
            this.$store.state.auth,
            uid
          );
        }

        Swal("Success", "Card deleted successfully.", "success");
        this.isDeleteModalOpen = false;
        this.cardToDelete = null;
        this.isLoading = false;
      } catch (error) {
        console.log("confirmDelete error:", error);
        Swal("Error", `${error.message} Failed to delete card.`, "error");
      } finally {
        this.isLoading = false;
        this.isDeleteModalOpen = false;
        this.cardToDelete = null;
      }
    },
    async confirmApprove() {
      this.isLoading = true;
      const cardId = this.cardToApprove.id;
      const trelloCard = this.cardToApprove;
      try {
        const current = this.editedCards[cardId];
        if (!current) throw new Error("No data found");
        await firebase.ApproveNewTicket(cardId, );
        const commonFields = {
          description: `${this.$store.state.auth.user.email} approved ${this.selectedEmployee.email}'s ticket "${trelloCard.taskName}"`,
          activityName: `${this.$store.state.auth.user.username} approved ${this.selectedEmployee.username}'s ticket "${trelloCard.taskName}" for ${this.selectedMonth} ${this.selectedYear}`
        }
        const adminActivity = {
        adminId: this.$store.state.auth.user.uid,
        activityOnUser: this.selectedEmployee.uid,
        activityOnUserName: this.selectedEmployee.username,
        activityByUserName: this.$store.state.auth.user.username || 'Admin',
        action: 'Approved',
        activityTitle: `approved ticket`,
        activityDescription: commonFields.description,
        activityName: commonFields.activityName,
        activityDescription: commonFields.description,
        activityName: commonFields.activityName,
        type: 'performance_edit',
        timestamp: new Date().toLocaleString('en-PK'),
        cardId: cardId,
        cardName: trelloCard.taskName,
        field: 'Task',
        change: `N/A`,
        oldValue: 'pending',
        newValue: 'approved',
        reason: null,
        month: this.selectedMonth,
        year: this.selectedYear,
        userRole: 'admin',
        source: 'UI'
      };
      await logAdminActivity(adminActivity);

        const { uid, username } = this.$store.state.auth.user;
        await handleActivityNotification(
          {
            type: "performance_edit",
            activityDescription: commonFields.description,
            activityOnUser: this.selectedEmployee.uid,
            activityOnUserName: this.selectedEmployee.username,
            activityByUserName: username,
            action: "approved",
            cardName: trelloCard.taskName,
            activityName: commonFields.activityName,
          },
          this.$store.state.auth,
          uid
        );

        const local = this.doneCards.find(c => c.id === cardId);
        if (local) {
          local.ticketStatus = 'approved';
        }
        Swal("Success", "Ticket approved successfully.", "success");
        this.isApproveModalOpen = false;
        this.cardToApprove = null;
      } catch (err) {
        console.error(err);
        Swal("Error", "Failed to approve ticket.", "error");
      } finally {
        this.isLoading = false;
      }
    },
  async saveChange() {
    this.isLoading = true;
    try {
      const { field, original, new: newVal, cardId, isCustom } = this.changeInfo;
      const required = !this.isAdmin && field === 'reopened';
      if (required && !this.reason.trim()) {
        Swal("Error", "Reason is required for this change.", "error");
        return;
      }
      const trelloCard = this.doneCards.find(c => c.id === cardId);
      if (!trelloCard) return;

      const minimalOriginal = {
        durationInProgress: trelloCard.durationInProgress || null,
        reopenCount: trelloCard.reopenCount || 0 ,
        score: trelloCard.score || 0,
        deadlineMissedCount: trelloCard.deadlineMissedCount || null,
        link: trelloCard.link || null,
        name: trelloCard.name,
        boardName: trelloCard.boardName ||trelloCard.name || null
      };
      const existing = this.editedCards[cardId] || {};
      const existingUpdated = existing.updatedData || {};

      const newValue = field === 'reopened' ? parseInt(newVal) : parseFloat(newVal);
      const reasonKey = field === 'reopened' ? 'reopenedReason' : 'scoreReason';
      const status = this.isAdmin ? 'approved' : 'pending';
      const fieldLabel = field === 'reopened' ? 'Reopened Count' : 'Score';
      const action = this.isAdmin ? "Updated" : "Requested";
      const mergedUpdated = {
        ...existingUpdated,
        [field]: newValue,
        [reasonKey]: this.reason || null,
        status,
      };

      const payload = {
        isCustom: trelloCard.isCustom ? true :null,
        reason: trelloCard.reason ? trelloCard.reason :null,
        customEdit: trelloCard.isCustom ? true : null,
        type: trelloCard.isCustom ? trelloCard.type : null,
        cardId,
        movedDate: trelloCard.movedDate || null,
        movedTime: trelloCard.movedTime || null,
        user: this.selectedEmployee.uid,
        year: this.selectedYear,
        month: this.selectedMonth,
        board: this.selectedBoardId || trelloCard.boardName || trelloCard.name || null,
        originalData: minimalOriginal,
        updatedData: mergedUpdated,
        status: status
      };
      const commonFields = {
        description: this.isAdmin
          ? `${this.$store.state.auth.user.email} ${action.toLowerCase()} ${this.selectedEmployee.email}'s ${fieldLabel.toLowerCase()} ${original} → ${newVal} for card "${trelloCard.name}" for ${this.selectedMonth} ${this.selectedYear} ${this.reason ? '. Reason: ' + this.reason : ''}`
          : `${this.selectedEmployee.email} ${action.toLowerCase()} ${fieldLabel.toLowerCase()} ${original} → ${newVal} for card "${trelloCard.name}" for ${this.selectedMonth} ${this.selectedYear} ${this.reason ? '. Reason: ' + this.reason : ''}`,

        activityName: this.isAdmin
          ? `${this.$store.state.auth.user.username} ${action.toLowerCase()} ${this.selectedEmployee.username}'s ${fieldLabel.toLowerCase()} ${original} → ${newVal} for card "${trelloCard.name}" for ${this.selectedMonth} ${this.selectedYear}`
          : `${this.selectedEmployee.username} ${action.toLowerCase()} ${fieldLabel.toLowerCase()} ${original} → ${newVal} for card ${trelloCard.name} for ${this.selectedMonth} ${this.selectedYear}`
      }
      const adminActivity = {
        adminId: this.$store.state.auth.user.uid,
        activityOnUser: this.selectedEmployee.uid,
        activityOnUserName: this.selectedEmployee.username,
        activityByUserName: this.$store.state.auth.user.username || 'Admin',
        action: action,
        activityTitle: `${fieldLabel} ${action.toLowerCase()}`,
        activityDescription: commonFields.description,
        activityName: commonFields.activityName,
        type: 'performance_edit',
        timestamp: new Date().toLocaleString('en-PK'),
        cardId: cardId,
        cardName: trelloCard.name,
        field: field,
        change :`${!original ? "0" : original} → ${newVal}`,
        oldValue: original,
        newValue: newVal,
        reason: this.reason || null,
        month: this.selectedMonth,
        year: this.selectedYear,
      };
      await logAdminActivity(adminActivity);

      const { uid, username } = this.$store.state.auth.user;
      await handleActivityNotification(
        {
          type: "performance_edit",
          activityName: commonFields.activityName,
          activityDescription: commonFields.description,
          activityOnUser: this.selectedEmployee.uid,
          activityOnUserName: this.selectedEmployee.username,
          activityByUserName: username,
          action: action,
          cardName: trelloCard.name,
          fieldLabel: fieldLabel,
        },
        this.$store.state.auth,
        uid
      );

      await firebase.saveEditedCard(payload);
      this.doneCards = this.doneCards.map(c => {
        if (c.id === cardId) {
          const updatedCard = { ...c };
          if (field === 'score') updatedCard.score = newValue;
          updatedCard.scoreReason = this.reason;
          return updatedCard;
        }
        return c;
      });
      const message = this.isAdmin 
          ? "Updated successfully." 
          : "Request saved successfully.";
      Swal("Success", message, "success");
      const local = this.doneCards.find(c => c.id === cardId);
      if (local) {
        if (field === 'reopened') {
          local.reopenCount = newValue;
          local.originalreopenCount = original;
        }
        if (field === 'score') local.score = newValue;
        local.__fbReason = this.reason;
        local.__fbField = field;
        local.status = status;
      }

      this.$set(this.editedCards, cardId, { updatedData: mergedUpdated });

      this.showReasonModal = false;
      this.cancelEdit(cardId, field);
        this.showReasonModal = false;
        this.pendingAction = null;
        this.pendingCardId = null;
        this.pendingField = null;
        this.reason = '';
    } catch (error) {
      console.error("saveChange error:", error);
      Swal("Error", error.message || "Something went wrong.", "error");
    } finally {
      this.isLoading = false;
    }
  },
    async approveEdit(cardId, field) {
      this.isLoading = true;
      const fb = this.editedCards[cardId];
      if (!fb || !fb.updatedData) return;
      const prefixedReason = this.reason.trim() ? `Approved reason: ${this.reason.trim()}` : null;
      const updatedData = {
        ...fb.updatedData,
        status: 'approved',
        ...(field === 'reopened' ? { reopenedReason: prefixedReason || null } : {}),
      };
      const payload = {
        cardId,
        updatedData,
        status: 'approved'
      };
      const trelloCard = this.doneCards.find(c => c.id === cardId);
      if (!trelloCard) return;
      const reasonKey = field === 'reopened' ? 'reopenedReason' : 'scoreReason';
      const status = this.isAdmin ? 'approved' : 'pending';
      const fieldLabel = field === 'reopened' ? 'Reopened Count' : 'Score';
      const action = "Approved";
      const newValue = field === 'reopened' ? parseInt(fb.updatedData.reopened) : parseFloat(fb.updatedData.score);
      const oldValue = field === 'reopened' ? parseInt(fb.originalData.reopenCount)|| 0 : parseFloat(fb.originalData.score);
      const commonFields = {
        description: `${this.$store.state.auth.user.email} ${action.toLowerCase()} ${this.selectedEmployee.email}'s ${fieldLabel.toLowerCase()} ${oldValue} → ${newValue} for card "${trelloCard.name}" for ${this.selectedMonth} ${this.selectedYear} ${this.reason ? '. Reason: ' + this.reason : ''}`,
        activityName: `${this.$store.state.auth.user.username} ${action.toLowerCase()} ${this.selectedEmployee.username}'s ${fieldLabel.toLowerCase()} ${oldValue} → ${newValue} for card "${trelloCard.name} for ${this.selectedMonth} ${this.selectedYear}`  
      }
      const adminActivity = {
        adminId: this.$store.state.auth.user.uid,
        activityOnUser: this.selectedEmployee.uid,
        activityOnUserName: this.selectedEmployee.username,
        activityByUserName: this.$store.state.auth.user.username || 'Admin',
        action: action,
        activityTitle: `${fieldLabel} ${action.toLowerCase()}`,
        activityDescription: commonFields.description,
        activityName: commonFields.activityName,
        type: 'performance_edit',
        timestamp: new Date().toLocaleString('en-PK'),
        cardId: cardId,
        cardName: trelloCard.name,
        field: field,
        change :`${!oldValue ? "0" : oldValue} → ${newValue}`,
        oldValue: oldValue,
        newValue: newValue,
        reason: this.reason || null,
        month: this.selectedMonth,
        year: this.selectedYear,
        reason: prefixedReason,
      };
      try {
        await firebase.saveApproveReject(payload);
        await logAdminActivity(adminActivity);

        const { uid, username } = this.$store.state.auth.user;
        await handleActivityNotification(
          {
            type: "performance_edit",
            activityDescription: commonFields.description,
            activityOnUser: this.selectedEmployee.uid,
            activityOnUserName: this.selectedEmployee.username,
            activityByUserName: username,
            action: action,
            fieldLabel: fieldLabel,
            activityName: commonFields.activityName,
          },
          this.$store.state.auth,
          uid
        );

        const local = this.doneCards.find(c => c.id === cardId);
        if (local) {
          local.status = 'approved';
          if (field === 'reopened') delete local.originalreopenCount;
        }

        this.$set(this.editedCards, cardId, { ...fb, updatedData });
        Swal("Approved", "Request approved Successfully", "success");
        this.isLoading = false;
        this.showReasonModal = false;
        this.pendingAction = null;
        this.pendingCardId = null;
        this.pendingField = null;
        this.reason = '';
      } catch (error) {
        this.isLoading = false;
        Swal("Error", "Failed to approve the change.", "error");
      }
    },

    async rejectEdit(cardId, field) {
      this.isLoading = true;
      const fb = this.editedCards[cardId];
      if (!fb || !fb.updatedData || !fb.originalData) return;
      const prefixedReason = this.reason.trim() ? `Rejection reason: ${this.reason.trim()}` : null;

      const updatedData = {
        ...fb.updatedData,
        status: 'rejected',
        ...(field === 'reopened' ? { reopenedReason: prefixedReason || null } : {}),
      };

      const payload = {
        cardId,
        updatedData,
        status: 'rejected'
      };
      const trelloCard = this.doneCards.find(c => c.id === cardId);
      if (!trelloCard) return;
      const reasonKey = field === 'reopened' ? 'reopenedReason' : 'scoreReason';
      const status = this.isAdmin ? 'approved' : 'pending';
      const fieldLabel = field === 'reopened' ? 'Reopened Count' : 'Score';
      const action = "Rejected";
      const newValue = field === 'reopened' ? parseInt(fb.updatedData.reopened) : parseFloat(fb.updatedData.score);
      const oldValue = field === 'reopened' ? parseInt(fb.originalData.reopenCount)|| 0 : parseFloat(fb.originalData.score);
      const commonFields = {
        description: `${this.$store.state.auth.user.email} ${action.toLowerCase()} ${this.selectedEmployee.email}'s ${fieldLabel.toLowerCase()}  ${oldValue} →  ${newValue} for card "${trelloCard.name}" for ${this.selectedMonth} ${this.selectedYear} ${this.reason ? '. Reason: ' + this.reason : ''}`,
        activityName: `${this.$store.state.auth.user.username} ${action.toLowerCase()} ${this.selectedEmployee.username}'s ${fieldLabel.toLowerCase()}  ${oldValue} → ${newValue} for card "${trelloCard.name} for ${this.selectedMonth} ${this.selectedYear}`   
      }
      const adminActivity = {
        adminId: this.$store.state.auth.user.uid,
        activityOnUser: this.selectedEmployee.uid,
        activityOnUserName: this.selectedEmployee.username,
        activityByUserName: this.$store.state.auth.user.username || 'Admin',
        action: action,
        activityTitle: `${fieldLabel} ${action.toLowerCase()}`,
        activityDescription: commonFields.description,
        activityName: commonFields.activityName,
        type: 'performance_edit',
        timestamp: new Date().toLocaleString('en-PK'),
        cardId: cardId,
        cardName: trelloCard.name,
        field: field,
        change :`${!oldValue ? "0" : oldValue} → ${newValue}`,
        oldValue: oldValue,
        newValue: newValue,
        reason: this.reason || null,
        month: this.selectedMonth,
        year: this.selectedYear,
        reason: prefixedReason,
      };

      try {
        await firebase.saveApproveReject(payload);
        await logAdminActivity(adminActivity);

        const { uid, username } = this.$store.state.auth.user;
        await handleActivityNotification(
          {
            type: "performance_edit",
            activityDescription: commonFields.description,
            activityOnUser: this.selectedEmployee.uid,
            activityOnUserName: this.selectedEmployee.username,
            activityByUserName: username,
            action: action,
            fieldLabel: fieldLabel,
            activityName: commonFields.activityName,
          },
          this.$store.state.auth,
          uid
        );

        const local = this.doneCards.find(c => c.id === cardId);
        if (local) {
          local.status = 'rejected';
          if (field === 'reopened') {
            local.reopenCount = fb.originalData.reopenCount;
            local.originalreopenCount = fb.originalData.reopenCount;
          }
        }

        this.$set(this.editedCards, cardId, { ...fb, updatedData });
        Swal("Rejected", "Change rejected and reverted to original value.", "warning");
        this.isLoading = false;
        this.showReasonModal = false;
        this.pendingAction = null;
        this.pendingCardId = null;
        this.pendingField = null;
        this.reason = '';
        } catch (error) {
        console.error("Reject failed:", error);
        Swal("Error", "Failed to reject the change.", "error");
          this.isLoading = false;
        }
    },

    showInfo(event, id, field) {
      this.showTooltip = id;
      this.currentHoverField = field;
      this.$nextTick(() => {
        const el = event.target;
        const rect = el.getBoundingClientRect();
        this.tooltipX = rect.left + rect.width / 2;
        this.tooltipY = rect.top + 15;
      });
    },

    getReasonForField(cardId, field) {
      const fb = this.editedCards[cardId];
      const item = this.doneCards.find(c => c.id === cardId);

      if (field === 'reason') {
        return item && item.reason ? item.reason : '';
      }
      if (field === 'score' && fb && fb.scoreReason !== undefined) {
          return fb.scoreReason;
        }
      if (!fb || !fb.updatedData) return null;
      if (fb.updatedData.approvalReason) return fb.updatedData.approvalReason;
      if (fb.updatedData.rejectionReason) return fb.updatedData.rejectionReason;
      const key = field === 'reopened' ? 'reopenedReason' : 'scoreReason';
      return fb.updatedData[key] || null;
    },

    hideInfo() {
      this.showTooltip = null;
      this.currentHoverField = null;
    },
  },
};
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/Performance/Performance.vue